import { FormHelperText, Paper, Stack, Typography, useMediaQuery, useTheme} from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import { selectLoggedInUser } from '../../auth/AuthSlice';
import { addToCartAsync,selectCartItems } from '../../cart/CartSlice';
import {motion} from 'framer-motion'

export const ProductCard = ({id,title,price,thumbnail,brand,stockQuantity,isWishlistCard,isAdminCard}) => {


    const navigate=useNavigate()
    const loggedInUser=useSelector(selectLoggedInUser)
    const cartItems=useSelector(selectCartItems)
    const dispatch=useDispatch()


    const theme=useTheme()
    const is1410=useMediaQuery(theme.breakpoints.down(1410))
    const is932=useMediaQuery(theme.breakpoints.down(932))
    const is752=useMediaQuery(theme.breakpoints.down(752))
    const is500=useMediaQuery(theme.breakpoints.down(500))
    const is608=useMediaQuery(theme.breakpoints.down(608))
    const is488=useMediaQuery(theme.breakpoints.down(488))
    const is408=useMediaQuery(theme.breakpoints.down(408))

    const isProductAlreadyInCart=cartItems.some((item)=>item?.product?._id===id)
    const brandName = !brand ? 'Nexocart Store' : typeof brand === 'object' ? brand?.name || 'Nexocart Store' : brand

    const handleAddToCart=async(e)=>{
        e.stopPropagation()
        const data={user:loggedInUser?._id,product:id,productData:{_id:id,title,price,images:[thumbnail],thumbnail,brand:{name:brandName},stockQuantity}}
        dispatch(addToCartAsync(data))
    }


  return (
    <>

    <motion.div initial="rest" animate="rest" whileHover="hover">
    <Stack
        component={isAdminCard?"":isWishlistCard?"":is408?'':Paper}
        mt={is408?2:0}
        elevation={1}
        p={2}
        width={is408?'auto':is488?"200px":is608?"240px":is752?"300px":is932?'240px':is1410?'300px':'340px'}
        sx={{cursor:"pointer", overflow:"hidden"}}
        onClick={()=>navigate(`/product-details/${id}`)}
    >

        {/* image display */}
        <Stack sx={{overflow:"hidden", borderRadius:1}}>
            <motion.img
                width={'100%'}
                height={'100%'}
                src={thumbnail}
                alt={title || 'Product thumbnail'}
                initial={{opacity:0, y:12, scale:.98}}
                animate={{opacity:1, y:0, scale:1}}
                variants={{
                    rest: { scale: 1 },
                    hover: { scale: 1.06 },
                }}
                transition={{duration:.35, ease:"easeOut"}}
                style={{aspectRatio:1/1,objectFit:"contain", display:"block"}}
            />
        </Stack>

        {/* lower section */}
        <Stack flex={2} justifyContent={'flex-end'} spacing={1} rowGap={2}>

            <Stack>
                <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
                    <Typography variant='h6' fontWeight={400}>{title}</Typography>
                </Stack>
                <Typography color={"text.secondary"}>{brandName}</Typography>
            </Stack>

            <Stack sx={{flexDirection:"row",justifyContent:"space-between",alignItems:"center"}}>
                <Typography>Rs. {price}</Typography>
                {
                    !isWishlistCard? isProductAlreadyInCart?
                    'Added to cart'
                    :
                    !isAdminCard &&
                    <motion.button  whileHover={{scale:1.030}} whileTap={{scale:1}} onClick={(e)=>handleAddToCart(e)} style={{padding:"10px 15px",borderRadius:"3px",outline:"none",border:"none",cursor:"pointer",backgroundColor:"black",color:"white",fontSize:is408?'.9rem':is488?'.7rem':is500?'.8rem':'.9rem'}}>
                        <div style={{display:"flex",alignItems:"center",columnGap:".5rem"}}>
                            <p>Add To Cart</p>
                        </div>
                    </motion.button>
                    :''
                }
                
            </Stack>
            {
                stockQuantity<=20 && (
                    <FormHelperText sx={{fontSize:".9rem"}} error>{stockQuantity===1?"Only 1 stock is left":"Only few are left"}</FormHelperText>
                )
            }
        </Stack>
    </Stack>
    </motion.div>
    </>
  )
}
